import ApproveListTable from './ApproveListTable';

export default ApproveListTable;
